import formBaseMixin from  '../../../components/form/form-base-mixin.js'
import userFriendlyEr from '../../../utils/userFriendlyEr.js'
import {STATUS_NOT_ACTIVE} from '../../../config/config.js'
import yearUtil from '../../../utils/year.js'
import {atu} from '../../../api/api-endpoints'

const ResidentModel = (year) => {
  return {
    year,
    apartment_building_residence: '',
    private_house_residence: '',
    resident_number: '',
    total: 0
  }
};

const Plan = () => ({
  mkd_year_meter: '',
  mkd_year_kg: '',
  village_year_meter: '',
  village_year_kg: ''
});

const Garbage = () => ({
  total: '',
  total_cubic: '',
  total_recast: '',
  total_recast_cubic: '',
  total_storage: '',
  total_storage_cubic: '',
  year: ''
});


export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        plan: new Plan(),
        garbage: new Garbage(),
        type_id: ''
      },
      years: [],
      currentResidentYear: {
        year: yearUtil.getCurrentYear()
      },
      currentResidents: {},
      currentGarbage: {
        year: ''
      },
      currentGarbageByAction: {
        year: ''
      }
    }
  },
  computed: {
    notActive () {
      return STATUS_NOT_ACTIVE
    },
    regionalOperators () {
      const items = this.$store.getters.readUrlEndpoint(this.getRegionalOperatorEndpoint());
      if (items && items.data) {
        return items.data
      }
      return []
    },
    localityVisibleColumns () {
      return {
        name: {label: 'Населенный пункт'},
        type: {label: 'Тип населенного пункта'}
      }
    },
    garbageVisibleColumns () {
      return {
        name: {label: 'Класс опасности'},
        value: {label: 'Образование отходов (тыс/тонн)'}
      }
    },
    garbageByActionVisibleColumns () {
      // return {
      //   label: {label: 'Сведения'},
      //   unit: {label: 'Ед. изм.'},
      //   value: {label: 'Величина'}
      // }
    },
    garbageYearsList () {
      let {min_year = null, max_year = null} = this.$store.getters.readUrlEndpoint(this.getAtuGarbageMaxMinYearEndpoint(this.$route)) || {};
      if (min_year && max_year) {
        return yearUtil.getSpecifiedYearsOptions(min_year, max_year)
      }
      return []
    },
    garbageByActionYearsList () {
      let {min_year = null, max_year = null} = this.$store.getters.readUrlEndpoint(this.getAtuGarbageByActionMaxMinYearEndpoint(this.$route)) || {};
      if (min_year && max_year) {
        return yearUtil.getSpecifiedYearsOptions(min_year, max_year)
      }
      return []
    },
    collections () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    geoObjectTypes () {
      return (this.collections.geo_object_type || []).map(v => ({
        id: v.id,
        name: v.name_full || v.name
      }))
    },
    availability() {
      return this.collections?.availability || []
    },
    parentItem () {
      return this.$store.getters.readUrlEndpoint(
        this.getItemEndpoint({
          params: {
            id: this.fields.parent_id
          }
        })
      )
    },
    parentItems () {
      let rootId = null;
      if (this.parentItem) {
        rootId = this.parentItem.parent_id
      }
      return this.$store.getters.readUrlEndpoint(
        this.getEndpoint({
          query: {
            parent_id: rootId || null,
            'per-page': -1
          }
        })
      )
    },
    parentItemsList () {
      let tmp = [];
      let parentId = this.fields.parent_id;
      let parentIdInList = false;
      if (this.parentItems && this.parentItems.data) {
        this.parentItems.data.forEach(v => {
          if (parentId == v.id) {
            parentIdInList = true
          }
          tmp.push({
            id: v.id,
            name: v.name_with_type
          })
        })
      }
      // server data return parent_id
      // which ignored in data grid parent_id filter on server
      // hide list if parent_id not exist in list
      return parentIdInList ? tmp : []
    }
  },
  watch: {
    'currentResidents': {
      handler: function (val, oldVal) {
        this.recalc()
      },
      deep: true
    }
  },
  methods: {
    mapTariffToFields (data) {
      let id = this.fields.id ? this.fields.id : 0;
      let tariff_id = data.id;
      this.$set(this.fields, Object.assign(this.fields, data));
      if(!this.fields.tariff_id){
        this.fields.tariff_id = tariff_id
      }
      if(id){
        this.fields.id = id
      }
    },
    prepareFieldsForSend (fields = {}) {
      // for prevent prefix
      delete this.fields.name_with_type;
      return fields
    },
    setCurrentGarbageByActionYear () {
      this.$refs.objectGarbageByAction.fetchData()
    },
    setCurrentGarbageYear () {
      this.$refs.objectGarbage.fetchData();
      this.$refs.objectMedicalGarbage.fetchData()
    },
    endpointGarbageByActionList () {
      return {
        url: (this.currentGarbageByAction.year ? atu.atuGarbageByActionByYear(
          this.$route.params.id,
          this.currentGarbageByAction.year
        ) : null)
      }
    },
    endpointGarbageList () {
      return {
        url: (this.currentGarbage.year ? atu.atuGarbageByYear(
          this.$route.params.id,
          this.currentGarbage.year
        ) : null)
      }
    },
    endpointGarbageMedicalList () {
      return {
        url: (this.currentGarbage.year ? atu.atuGarbageMedicalByYear(
          this.$route.params.id,
          this.currentGarbage.year
        ) : null)
      }
    },
    endpointLocalityList (ctx) {
      let route = {
        query: {}
      };

      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      return {
        url: atu.locality(this.$route.params.id, route)
      }
    },
    recalc () {
      let sum = +this.currentResidents.apartment_building_residence + (+this.currentResidents.private_house_residence);
      if (!isNaN(sum)) {
        this.$set(this.currentResidents, 'total', sum)
      }
    },
    generateYears () {
      let yearsRange = [];

      for (let i = 2013; i < 2051; i++) {
        yearsRange.push({id: i, name: i})
      }

      return yearsRange
    },
    setCurrentResidents () {
      for (let year in this.fields.resident_number_by_year) {
        if (+year === +this.currentResidentYear.year) {
          this.currentResidents = this.fields.resident_number_by_year[year];
          return true
        }
      }
      let year = +this.currentResidentYear.year;
      this.fields.resident_number_by_year[year] = new ResidentModel(year);
      this.currentResidents = this.fields.resident_number_by_year[year];
      return false
    },
    afterSave: async function () {
      let errors = [];

      // save residents
      if (!this.fields.resident_number_by_year) {
        this.fields.resident_number_by_year = {}
      }
      for (let y in this.fields.resident_number_by_year) {
        let data = Object.assign({}, this.fields.resident_number_by_year[y]);
        data.year = y;
        try {
          await this.$store.dispatch('updateModel', {
            url: atu.atuObjectDetail(this.fields.id, y),
            data: data
          })
        } catch (e) {
          console.log(e);
          errors.push(y + ' год: ' + userFriendlyEr.recognize(e))
        }
      }

      if (errors.length > 0) {
        console.log(errors);
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
      }
      if (!this.fields.resident_number_by_year) {
        this.fields.resident_number_by_year = {}
      }
      if (this.fields.tkoOperator) {
        this.fields.tko_operator_id = this.fields.tkoOperator.id
      }
      if (!this.fields.plan) {
        this.fields.plan = new Plan()
      }
      if (!this.fields.garbage) {
        this.fields.garbage = new Garbage()
      }
      this.update()
    },
    update() {
      this.years = this.generateYears();
      this.setCurrentResidents()
    },
    deleteLocality (item) {
      this.$e.confirmBox(
        'Населенный пункт будет удален из состава муниципального образованая. Продолжить?',
        '',
        'Продолжить'
      ).then(() => {
        this.$store.dispatch('deleteModel', {
          url: atu.deleteLocality(this.fields.id, item.id),
          data: {
            id: item.id
          }
        }).then(r => {
          this.$e.successBox();
          this.$refs.localityTable.fetchData()
        }).catch(erResponse => {
          this.$e.errorBox(erResponse)
        })
      })
    }
  },
  asyncData: async function ({store, route, fromRoute, methods}) {
    let promises = [];
    let itemResponse = null;
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      itemResponse = await store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)})
    }

    if (methods.getRegionalOperatorEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getRegionalOperatorEndpoint(),
        fromCache: true
      }))
    }

    if (methods.getAtuGarbageMaxMinYearEndpoint && methods.getAtuGarbageMaxMinYearEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getAtuGarbageMaxMinYearEndpoint(route, fromRoute)}))
    }

    if (methods.getAtuGarbageByActionMaxMinYearEndpoint && methods.getAtuGarbageByActionMaxMinYearEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getAtuGarbageByActionMaxMinYearEndpoint(route, fromRoute)}))
    }

    if (methods.getAtuGarbageByActionMaxMinYearEndpoint && methods.getAtuGarbageByActionMaxMinYearEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getAtuGarbageByActionMaxMinYearEndpoint(route, fromRoute)}))
    }

    if (methods.getCollectionEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true,
        params: {
          disableGlobalError: true
        }
      }))
    }

    let parentId = null;
    if (itemResponse && itemResponse.data) {
      parentId = itemResponse.data.parent_id
    } else if (route.query.setFields) {
      let fields = JSON.parse(route.query.setFields);
      parentId = fields.parent_id
    }
    if (parentId) {
      let parentRoute = {
        params: {
          id: parentId
        }
      };
      if (methods.getItemEndpoint(parentRoute) !== null) {
        let parentResponse = await store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(parentRoute)});
        let rootId = parentResponse.data.parent_id;
        await store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getEndpoint({
            query: {
              parent_id: rootId || null,
              'per-page': -1
            }
          })
        })
      }
    }

    if (promises.length > 0) {
      await Promise.all(promises)
    }

    return Promise.resolve(1)
  }
}

